
import { TreatmentServicesSection } from "@/components/services/TreatmentServicesSection";
import { wisdomToothData } from "./wisdomToothData";

export const WisdomToothServices = () => {
  return (
    <TreatmentServicesSection
      title="Our Wisdom Tooth Services"
      subtitle="Services We Offer"
      description="At Asrani Dental in Sadar, Nagpur, we provide comprehensive solutions for all types of wisdom tooth issues."
      services={wisdomToothData.services}
      cardStyle="gradient"
    />
  );
};
